import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

import styles from './MagazineArticle.module.scss';

interface MagazineArticleProps {
  variant?: 'large' | 'small';
  category: string;
  date: string;
  title: string;
  text: string;
  imageSrc?: string;
  href: string;
}

export const MagazineArticle: React.FC<MagazineArticleProps> = ({
  variant = 'large',
  category,
  date,
  title,
  text,
  imageSrc,
  href,
}) => (
  <Link href={href}>
    <a>
      <article className={`${styles.container} ${styles[variant]}`}>
        <div className={styles.image}>
          {imageSrc && <Image src={imageSrc} width={610} height={370} alt={title} />}
        </div>
        <div className={styles.info}>
          <span className={styles.category}>{category}</span>
          <span className={styles.date}>{new Date(date).toLocaleDateString('sv-SE')}</span>
        </div>
        <h3>{title}</h3>
        <p>{text}</p>
      </article>
    </a>
  </Link>
);
